import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';
import { commonMessages } from 'src/utils/messages';
import { servicePlansMessages } from 'src/features/servicePlans/utils/messages';
import { ServicePlanItemFormSchemaValues } from 'src/features/servicePlanItems/utils/formSchema';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { BOOLEAN_MAP, BOOLEAN_OPTIONS } from 'src/features/moneyAccounts/utils/constants';
import { servicePlanItemsMessages } from 'src/features/servicePlanItems/utils/messages';
import { METRIC_TRANSACTIONS_MAP } from 'src/features/servicePlanItems/utils/constants';
import { SERVICE_PLAN_ITEMS_METRICS } from 'src/features/servicePlanItems/utils/types';

type ServicePlanItemFormProps = {
    form: UseFormReturn<ServicePlanItemFormSchemaValues>;
    onSubmit: (values: ServicePlanItemFormSchemaValues) => void;
};

function ServicePlanItemForm({ onSubmit, form }: ServicePlanItemFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<ServicePlanItemFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(commonMessages.name)}
            />
            <InputFormField<ServicePlanItemFormSchemaValues>
                form={form}
                name="code"
                label={formatMessage(servicePlansMessages.code)}
            />
            <SelectFormField<ServicePlanItemFormSchemaValues>
                form={form}
                name="is_required"
                isBoolean={true}
                label={formatMessage(servicePlanItemsMessages.isRequired)}
                options={Object.values(BOOLEAN_OPTIONS)}
                optionTranslationMap={BOOLEAN_MAP}
            />
            <SelectFormField<ServicePlanItemFormSchemaValues>
                form={form}
                name="metric"
                required={false}
                label={formatMessage(servicePlanItemsMessages.metric)}
                options={Object.values(SERVICE_PLAN_ITEMS_METRICS)}
                optionTranslationMap={METRIC_TRANSACTIONS_MAP}
            />
            <InputFormField<ServicePlanItemFormSchemaValues>
                form={form}
                name="external_item_id"
                type="number"
                required={false}
                label={formatMessage(servicePlanItemsMessages.externalId)}
            />
            <InputFormField<ServicePlanItemFormSchemaValues>
                form={form}
                name="starting_quantity"
                type="number"
                required={false}
                label={formatMessage(servicePlanItemsMessages.startingQuantity)}
            />
        </Form>
    );
}

export default ServicePlanItemForm;
